import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
});

function raf(time) {
  lenis.raf(time);
  ScrollTrigger.update();
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// let sections = gsap.utils.toArray(".horizontalScrollSection");

// let scrollTween = gsap.to(sections, {
//     xPercent: -100 * (sections.length - 1),
//     ease: "none", // <-- IMPORTANT!
//     scrollTrigger: {
//       trigger: ".horizontalScrollContainer",
//       pin: true,
//       scrub: 0.5,
//       //snap: directionalSnap(1 / (sections.length - 1)),
//       end: "+=3000"
//     }
//   });

const menuOpen = document.getElementById("open");
const menuClose = document.getElementById("close");

menuOpen.addEventListener("click", () => {
  gsap.to(".menuContentHidden", {
    y: "0",
    duration: 0.5,
  });
});

menuClose.addEventListener("click", () => {
  gsap.to(".menuContentHidden", {
    y: "-100vh",
    duration: 0.5,
  });
});

gsap.to(".zoomImageFullScreen", {
  scrollTrigger: {
    trigger: ".imageFullScreen",
    start: "-200% top",
    scrub: 0.2,
    // markers:true,
    end: "150% top",
    // pin:true,
    toggleActions: "restart pause resume pause",
  },
  scale: 1,
  duration: 0.1,
});

gsap.to(".girlMove", {
  scrollTrigger: {
    trigger: ".secondPage",
    start: "-50% top",
    scrub: 0.2,
    // markers: true,
    end: "120% top",
    // pin:true,
    toggleActions: "re9start pause resume pause",
  },
  y: "-20vh",
  rotation: -20,
  duration: 0.1,
});

gsap.to(".boyMove", {
  scrollTrigger: {
    trigger: ".secondPage",
    start: "-60% top",
    scrub: 0.2,
    // markers: true,
    end: "120% top",
    // pin:true,
    toggleActions: "re9start pause resume pause",
  },
  y: "-40vh",
  rotation: 20,
  duration: 0.1,
});

let fourthPageTextRevealAnimationTimeline = gsap.timeline({
  scrollTrigger: {
    trigger: ".fourthPage",
    start: "top top",
    // markers: true,
    // end: "bottom top",
    pin: true,
    scrub: 1,
  },
});

fourthPageTextRevealAnimationTimeline.to(".fourthPageUnder", { opacity: 0 }, "runSame");
fourthPageTextRevealAnimationTimeline.to(".opacityShow", { opacity: 1 });


